module.exports = __webpack_public_path__ + "img/shape3.65cbcdb9.svg";